import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const BRAND_TEAL = '#2ec4b6';
const BRAND_YELLOW = '#ffe066';

const SectionWrap = styled(Box)({ marginTop: 22, marginBottom: 22 });

const SectionLabel = styled(Typography)({
  fontFamily: 'Helvetica Inserat, Impact, sans-serif',
  fontSize: '0.75rem',
  letterSpacing: '0.32em',
  color: '#888',
  textTransform: 'uppercase',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: 14,
});

const Row = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});

const Card = styled(Box)({
  background: 'linear-gradient(135deg, rgba(255,224,102,0.18) 0%, rgba(255,255,255,0.85) 100%)',
  borderLeft: `4px solid ${BRAND_YELLOW}`,
  borderRadius: 8,
  padding: '14px 18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 56,
  width: '100%',
  maxWidth: 360,
  boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
});

const Label = styled(Typography)({
  fontFamily: 'Helvetica Inserat, Impact, sans-serif',
  fontSize: '0.95rem',
  letterSpacing: '0.18em',
  color: '#0f4a44',
  textTransform: 'uppercase',
  fontWeight: 700,
});

const FinaleCard = ({ currentPhase }) => {
  if (currentPhase !== 'finalJeopardy' && currentPhase !== 'assembly') return null;
  const isComplete = currentPhase === 'assembly';
  return (
    <SectionWrap>
      <SectionLabel>The Finale</SectionLabel>
      <Row>
        <Card>
          <Label>The Grand Finale</Label>
          {isComplete ? (
            <CheckCircleIcon data-testid="finale-complete-icon" sx={{ color: BRAND_TEAL, fontSize: 24 }} />
          ) : (
            <CircularProgress size={20} thickness={4} sx={{ color: BRAND_TEAL }} />
          )}
        </Card>
      </Row>
    </SectionWrap>
  );
};

export default FinaleCard;
